__turbopack_context__.v({
  "wrapper": "ArticleModuleImage-module-scss-module__nBl2va__wrapper",
  "zoomIconRoot": "ArticleModuleImage-module-scss-module__nBl2va__zoomIconRoot",
});
